import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip } from "recharts";

const COLORS = ["#6366F1", "#0EA5E9", "#F59E0B", "#10B981", "#EC4899", "#64748B"];

const AudienceDonutChart = ({ title, subtitle, data = [] }) => {
    let chartData = data.map((item) => ({
        name: item.label || "Unknown",
        value: Number(item.visitors || 0),
    }));

    if (chartData.length > 6) {
        const first = chartData.slice(0, 5);
        const others = chartData.slice(5);
        first.push({ name: "Others", value: others.reduce((sum, item) => sum + item.value, 0) });
        chartData = first;
    }

    const total = chartData.reduce((sum, item) => sum + item.value, 0) || 1;

    return (
        <div className="rounded-xl border border-slate-200 bg-gradient-to-br from-indigo-50/40 to-white p-5">
            <h3 className="text-sm font-semibold text-slate-900">{title}</h3>
            <p className="mb-3 text-xs text-slate-500">{subtitle}</p>

            <div className="flex items-center gap-4">
                <div className="h-40 w-40 shrink-0">
                    <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                            <Pie data={chartData} dataKey="value" nameKey="name" innerRadius={45} outerRadius={70} paddingAngle={2}>
                                {chartData.map((entry, index) => (
                                    <Cell key={index} fill={COLORS[index % COLORS.length]} />
                                ))}
                            </Pie>
                            <Tooltip
                                formatter={(value) => [value.toLocaleString(), "Visitors"]}
                                contentStyle={{ borderRadius: 10, border: "1px solid #E2E8F0", fontSize: 12 }}
                            />
                        </PieChart>
                    </ResponsiveContainer>
                </div>

                <div className="min-w-0 flex-1 space-y-1.5">
                    {chartData.map((entry, index) => (
                        <div key={entry.name} className="flex items-center justify-between gap-2 text-xs">
                            <span className="flex min-w-0 items-center gap-1.5">
                                <span
                                    className="h-2 w-2 shrink-0 rounded-full"
                                    style={{ background: COLORS[index % COLORS.length] }}
                                />
                                <span className="truncate text-slate-600" title={entry.name}>{entry.name}</span>
                            </span>
                            <span className="shrink-0 font-semibold text-slate-900">
                                {((entry.value / total) * 100).toFixed(0)}%
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default AudienceDonutChart;